import React, { useEffect, useState } from 'react';
import { getRequest, deleteRequest, patchRequest } from 'apis/ApiInstence';
import AdminTable from 'common/AdminTable';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa';

const ListStories = () => {
    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchStories = async () => {
        try {
            setLoading(true);
            const res = await getRequest('success-stories?all=true');
            setStories(res?.data || []);
        } catch (err) {
            console.error('Failed to fetch stories:', err);
            toast.error("Failed to load success stories list.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this success story?")) {
            try {
                await deleteRequest(`success-stories/${id}`);
                toast.success("Success story deleted successfully!");
                fetchStories();
            } catch (err) {
                console.error(err);
                toast.error("Failed to delete success story.");
            }
        }
    };

    const handleStatusToggle = async (id, currentStatus) => {
        try {
            await patchRequest(`success-stories/${id}`, { is_active: !currentStatus });
            toast.success("Success story status updated successfully!");
            fetchStories();
        } catch (err) {
            console.error(err);
            toast.error("Failed to update status.");
        }
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                row.original.image ? (
                    <img
                        src={`${process.env.REACT_APP_BACKEND}uploads/${row.original.image}`}
                        alt="story"
                        width={70}
                        height={50}
                        style={{ objectFit: 'cover', borderRadius: '4px' }}
                    />
                ) : (
                    <div style={{
                        width: '70px',
                        height: '50px',
                        borderRadius: '4px',
                        backgroundColor: '#ccc',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold',
                        fontSize: '11px'
                    }}>
                        No Image
                    </div>
                )
            ),
        },
        {
            Header: 'Startup Name',
            accessor: 'startupName',
            Cell: ({ row }) => (
                <div className="text-left font-weight-bold">
                    {row.original.startupName}
                </div>
            )
        },
        {
            Header: 'Founder Name',
            accessor: 'founderName',
        },
        {
            Header: 'Video Link',
            accessor: 'videoUrl',
            Cell: ({ row }) => (
                row.original.videoUrl ? (
                    <a
                        href={row.original.videoUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-outline-danger"
                    >
                        <FaYoutube size={16} className="mr-1" /> Watch Video
                    </a>
                ) : (
                    <span className="text-muted" style={{ fontSize: '12px' }}>No link</span>
                )
            )
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <button
                    className={`btn btn-sm ${row.original.is_active ? 'btn-success' : 'btn-secondary'}`}
                    onClick={() => handleStatusToggle(row.original.id, row.original.is_active)}
                    style={{ minWidth: '85px' }}
                >
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </button>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex justify-content-center">
                    <Link
                        className="btn btn-sm btn-info mr-2"
                        to={`/stories/update/${row.original.id}`}
                    >
                        Edit
                    </Link>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(row.original.id)}
                    >
                        Delete
                    </button>
                </div>
            ),
        }
    ];

    useEffect(() => {
        fetchStories();
    }, []);

    return (
        <>
            <div className="container-fluid mt-4">
                {/* Premium Animated Header Banner */}
                <div 
                    className="dashboard-header-card d-flex align-items-center justify-content-between mb-4 mx-2 shadow-lg" 
                    style={{ 
                        background: 'linear-gradient(135deg, #0d47a1 0%, #00695c 100%)', 
                        padding: '1.5rem 2rem', 
                        borderRadius: '15px',
                        animation: 'fadeInUp 0.6s ease-out forwards'
                    }}
                >
                    <div className="d-flex align-items-center">
                        <div className="icon-circle mr-3" style={{ background: 'rgba(255,255,255,0.2)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="fa fa-award text-white" style={{ fontSize: '24px' }}></i>
                        </div>
                        <div>
                            <h3 className="text-white font-weight-bold mb-0" style={{ letterSpacing: '0.5px' }}>Success Stories</h3>
                            <p className="text-white-50 mb-0 small">Celebrate and manage achievements</p>
                        </div>
                    </div>
                    <Link 
                        className="btn btn-light font-weight-bold shadow-sm" 
                        to="/stories/add"
                        style={{ color: '#0d47a1', borderRadius: '8px', padding: '10px 20px', transition: 'all 0.3s' }}
                        onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 5px 15px rgba(255,255,255,0.3)'; }} onFocus={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 5px 15px rgba(255,255,255,0.3)'; }}
                        onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }} onBlur={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
                    >
                        <i className="fa fa-plus mr-2"></i>
                        Add New Story
                    </Link>
                </div>
                
                {loading ? (
                    <div className="text-center my-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : stories.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={stories} />
                ) : (
                    <div className="text-center my-5">
                        <p>No success stories found.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default ListStories;
